import {Component, Input} from "@angular/core";
import {ServiceBagService, ServiceBagServices} from "../../../../../base/component/ServiceBag";
import {BaseState, CredentialInfo, UserLogin} from "../../../../../base/entities/BaseEntities";
import {BaseGridComponent} from "../../../../../base/component/BaseGridComponent";


@Component({
    providers: ServiceBagServices,
    selector: 'app-user-login-history-grid',
    templateUrl: './user-login-history-grid.component.html'
})
export class UserLoginHistoryGridComponent extends BaseGridComponent<UserLogin, BaseState>
{
    @Input() CredentialsInfo: CredentialInfo[];
    
    constructor(A: ServiceBagService)
    {
        super(A, 'UserLoginGridComponent', UserLogin, BaseState);
    }
}